import React from "react";
import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <h1>Social Media Icon Group Tool</h1>

      <h2>A. Set up Social Media</h2>
      <p>Enter related Social Media Info</p>
      <ol className="form-inline">
        <li>
          <input type="text" size="10" placeholder="Facebook (en)" />{" "}
          <input type="text" size="10" placeholder="fa fa-facebook" />{" "}
          <input
            type="text"
            size="48"
            placeholder="https://www.facebook.com/fivebranchesuniversity"
          />
          <button type="text">x</button>
        </li>
        <li>
          <input type="text" size="10" placeholder="Facebook (ch)" />{" "}
          <input type="text" size="10" placeholder="fa fa-facebook" />{" "}
          <input
            type="text"
            size="48"
            placeholder="https://www.facebook.com/fivebranches.chinese/"
          />
          <button type="text">x</button>
        </li>
        <li>
          <input type="text" size="10" placeholder="Instagram" />{" "}
          <input type="text" size="10" placeholder="fa fa-instagram" />{" "}
          <input
            type="text"
            size="48"
            placeholder="https://www.instagram.com/fivebranchesuniversity/"
          />
          <button type="text">x</button>
        </li>
        <li>
          <input type="text" size="10" placeholder="LinkedIn" />{" "}
          <input type="text" size="10" placeholder="fa fa-linkedin" />{" "}
          <input
            type="text"
            size="48"
            placeholder="https://www.linkedin.com/company/five-branches-university"
          />
          <button type="text">x</button>
        </li>
        <li>
          <input type="text" size="10" placeholder="TikTok" />{" "}
          <input type="text" size="10" placeholder="fab fa-tiktok" />{" "}
          <input
            type="text"
            size="48"
            placeholder="https://www.tiktok.com/@fivebranches"
          />
          <button type="text">x</button>
        </li>
        <li>
          <input type="text" size="10" placeholder="Twitter" />{" "}
          <input type="text" size="10" placeholder="fa fa-twitter" />{" "}
          <input
            type="text"
            size="48"
            placeholder="https://twitter.com/fivebranches"
          />
          <button type="text">x</button>
        </li>
        <li>
          <input type="text" size="10" placeholder="WeChat" />{" "}
          <input type="text" size="10" placeholder="fa fa-weixin" />{" "}
          <input
            type="text"
            size="48"
            placeholder="https://www.fivebranches.edu"
          />
          <button type="text">x</button>
        </li>
        <li>
          <input type="text" size="10" placeholder="YouTube" />{" "}
          <input type="text" size="10" placeholder="fa fa-youtube" />{" "}
          <input
            type="text"
            size="48"
            placeholder="https://www.youtube.com/c/FiveBranchesUniversity/featured"
          />
          <button type="text">x</button>
        </li>
      </ol>
      <button type="text">Add New</button>
      <blockquote>
        <p>
          <b>F.A.: Font Awesome</b>
        </p>
        <p>
          Get F.A. icon codes here {"> "}
          <a href="https://fontawesome.com/v5/search" target="_blank">
            Font Awesome Icons
          </a>
        </p>
      </blockquote>
      <h2>B. Set Combination and Display Order</h2>
      <p>
        Enter the number available from above entries (non-blank entries).
        <br />
        The number of icons displayed is the number of icons entered in the
        input box.
      </p>
      <div className="form-inline">
        <p>
          <b>For English pages: &nbsp;</b>
        </p>
        <input type="text" placeholder="Example: 2, 1, 3, 4" />
        <p>
          <b>For Chinese pages: &nbsp;</b>
        </p>
        <input type="text" placeholder="Example: 2, 1, 5, 7" />
      </div>

      <h2>C. "and More..." Settings</h2>
      <div className="form-inline">
        <p>
          <b>For English pages: &nbsp;</b>
        </p>
        <p>
          Link text: <input type="text" placeholder="and More..." /> Link URL:{" "}
          <input type="text" placeholder="URL for 'and More...'" />
        </p>
        <p>
          <b>For Chinese pages: &nbsp;</b>
        </p>
        <p>
          Link text: <input type="text" placeholder="and More..." /> Link URL:{" "}
          <input type="text" placeholder="URL for 'and More...'" />
        </p>
      </div>
    </div>
  );
}
